import React from 'react'

const Tutorial = () => {
  return (<>

    <div className='TUTORIAL_CARD'>
        <div className='TUTORIAL_DETAILS'>
            <label>Talent without work is nothing </label>
            <button className='TUTORIAL_BUTTON'>Tutorial</button>
        </div>
        <img src='spider.png'/>
        <button className='CLOSE_BUTTON'>x</button>
    </div>

    </>)
}

export default Tutorial